<template>
    <v-container fluid tag="section" class="module-report-container">
        <v-row>
            <v-col cols="8" style="width:75%">
            </v-col>
            <v-col cols="3" style="position: relative;bottom: 8px;max-width:22% !important">
                <common-range-picker
                    v-model="selectRange"
                    :clearable="false"
                    :aLight="'left'"
                    :defaultRange="defaultRange"
                    :label="'Tìm kiếm theo thời gian'"
                />
            </v-col>
            <v-col cols="1">
                <v-btn
                    @click="changeDateRange(selectRange)"
                    color="primary"
                >
                    Tìm kiếm
                </v-btn>
            </v-col>
        </v-row>
        <module-report-table 
            :data="data"
            :total="total"
        />
    </v-container>
</template>

<script>
import moment from 'moment'
import ModuleReportTable from './components/ModuleReportTable'
import RepositoryFactory from "@/repositories/RepositoryFactory"
const ReportRepository = RepositoryFactory.get('report')

export default {
    components: {
        ModuleReportTable
    },
    data() {
        return {
            filterForm: {
                dateRange: {
                    startDate: moment().startOf('week').format('YYYY-MM-DD'),
                    endDate: moment().endOf('week').format('YYYY-MM-DD'),
                }
            },
            defaultRange: {
                startDate: moment().startOf('week').format('YYYY-MM-DD'),
                endDate: moment().endOf('week').format('YYYY-MM-DD'),
            },
            selectRange: [
                moment().startOf('week').format('YYYY-MM-DD'),
                moment().endOf('week').format('YYYY-MM-DD')
            ],
            total: {},
            data: [],
            dataChildTable: []
        }
    },
    created() {
        this.getDataType()
        // if (this.tab == 0) {
        //     this.getDataType()
        // } else if (this.tab == 1) {
        //     this.getDataSchoolLevel()
        // }
    },
    // watch: {
    //     tab: {
    //         deep: true,
    //         handler(newVal) {
    //             this.changeTab(newVal)
    //         }
    //     }
    // },
    methods: {
        async getDataType() {
            const loading = this.$loading.show()
            const params = {
                startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
                endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
            }
            const res = await ReportRepository.moduleTypeReport(params)

            if (res.success) {
                this.data = _.get(res, 'data.types', [])
                this.total = _.get(res, 'data.total', {})
            } else {
                this.data = []
                this.total = {}
                this.$swal({
                    title: 'Lỗi!',
                    text: _.get(res, 'message', '')
                })
            }
            loading.hide()
        },

        async getDataSchoolLevel() {
            const loading = this.$loading.show()
            const params = {
                startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
                endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
            }
            const res = await ReportRepository.moduleSchoolLevelReport(params)

            if (res.success) {
                this.data = _.get(res, 'data.schoolLevels', [])
                this.total = _.get(res, 'data.total', {})
            } else {
                this.data = []
                this.total = {}
                this.$swal({
                    title: 'Lỗi!',
                    text: _.get(res, 'message', '')
                })
            }
            loading.hide()
        },

        // async getDataChild() {
        //     this.dataChildTable = [];
        //     const params = {
        //         startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        //         endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        //     }
        //     const res = await ReportRepository.moduleSchoolLevelReport(params)

        //     if (res.success) {
        //         res.data.schoolLevels.forEach(item => {
        //             this.dataChildTable.push({'name': item.name});
        //         });
        //     } else {
        //         this.$swal({
        //             title: 'Lỗi!',
        //             text: _.get(res, 'message', '')
        //         })
        //     }
        // },

        // changeTab(tab) {
        //     if (tab == 0) {
        //         this.getDataType()
        //     } else if (tab == 1) {
        //         this.getDataSchoolLevel()
        //     }
        // },

        changeDateRange (selectRange) {
            const loading = this.$loading.show()
            this.filterForm.dateRange = {
                startDate: moment(selectRange[0]).format('YYYY-MM-DD'),
                endDate: moment(selectRange[1]).format('YYYY-MM-DD'),
            };
            this.selectRange = selectRange
            this.getDataType()
            loading.hide()
            // this.changeTab(this.tab)
        }

    }
}
</script>

<style scoped>
.module-report-container {
    background: white;
}
</style>